import { camelCase, pick } from 'lodash';
import { identity } from 'lodash/fp';
import queryString from 'query-string';
import { getSavedDisplayEmployeeLimit } from '../components/utils';

export const defaultQuery = {
  role_type: 'all',
  _page: '1',
  sort_type: 'staff_code__asc'
};

export const convertQueryToForm = query => {
  return Object.assign(
    { sortType: `${query.sort}__${query.order}` },
    ...Object.entries(query)
      .map(([k, v]) => [k[0] === '_' ? `_${camelCase(k)}` : camelCase(k), v])
      .map(([k, v]) => convertQueryToFormField(k, v))
      .filter(identity)
  );
};

const convertQueryToFormField = (fieldName, value) => {
  switch (fieldName) {
    case '_page':
      return { page: value };
    case 'sort':
    case 'order':
      return undefined;
    default:
      return { [fieldName]: value };
  }
};

export const getCurrentQueryFromLocation = (location, user) => {
  return {
    ...defaultQuery,
    ...queryString.parse(location.search, { arrayFormat: 'bracket' }),
    limit: getSavedDisplayEmployeeLimit(location.pathname, user)
  };
};

export const convertFormToGraphQl = formValues => {
  const [sortColumn, sortOrder] = (formValues.sortType || convertQueryToForm(defaultQuery).sortType).split('__');
  return {
    page: +formValues.page || 1,
    limit: +formValues.limit || 100,
    search: {
      ...(formValues.roleType !== 'all' && pick(formValues, 'roleType')),
      ...pick(formValues, 'q'),
      sortColumn,
      sortOrder
    }
  };
};
